import classNames from 'classnames'
import { Icon, type IIconsVector, type IStatusProps, Status, Typography } from 'shared/ui'

import styles from './styles.module.scss'

export type IPresetCardBadge = 'comingSoon' | 'new'

export type IPresetCardProps = {
  icon: IIconsVector
  name: string
  description: string
  selected?: boolean
  disabled?: boolean
  onClick?: () => void
  badge?: IPresetCardBadge
  id?: string
}

const BADGE_MAP: Record<IPresetCardBadge, IStatusProps> = {
  comingSoon: { title: 'Coming soon', intent: 'white_label', emphasis: 'low' },
  new: { title: 'New', intent: 'purple', emphasis: 'high' },
}

export const PresetCard = ({
  icon,
  name,
  description,
  selected,
  disabled,
  onClick,
  badge,
  id,
}: IPresetCardProps) => {
  const badgeStatus = badge ? BADGE_MAP[badge] : undefined

  return (
    <section
      id={id}
      className={classNames(styles.card, {
        [styles.cardSelected]: selected,
        [styles.cardDisabled]: disabled,
      })}
      onClick={disabled ? undefined : onClick}
    >
      <div className={styles.cardHeader}>
        <Icon
          icon={icon}
          fontSize={28}
          color={disabled ? 'var(--content-primary-disabled)' : 'var(--content-brand-primary)'}
        />
        {badgeStatus && (
          <Status
            className={styles.cardBadge}
            typographyProps={{
              variant: 'body-xs-medium',
              ariaLabel: badgeStatus.title,
              className: styles.cardBadgeText,
            }}
            {...badgeStatus}
          />
        )}
      </div>
      <div className={styles.cardContent}>
        <Typography
          variant='body-md-medium'
          color={disabled ? 'var(--content-primary-secondary)' : 'var(--content-primary-primary)'}
          ellipsis
          ariaLabel='PresetCard_title'
        >
          {name}
        </Typography>
        <Typography
          variant='body-md-regular'
          color={disabled ? 'var(--content-primary-disabled)' : 'tertiary'}
          ariaLabel='PresetCard_description'
        >
          {description}
        </Typography>
      </div>
    </section>
  )
}
